//import {getFunctions, httpsCallable} from "firebase/functions";
import {ServiceTemplateGeneric} from "./ServiceTemplateGeneric";

export class ServiceTemplateUser extends ServiceTemplateGeneric{

    constructor(organizationId,enterprise) {
        super(organizationId,enterprise,"serviceUserList","serviceUserId");
    }
}
